import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutletComponent, WrapperComponent } from '@shared/ui/components';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';

import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { BreadcrumbsModule, BreadcrumbsService } from '@shared/modules/page-settings';
import { MenuItem } from '@openng/optimus-ui/api';
import { Breadcrumb } from '@openng/optimus-ui/breadcrumb';
import { filter, map } from 'rxjs/operators';
import { WINDOW } from '@shared/utils';

@Component({
  imports: [
    CommonModule,
    RouterOutletComponent,
    FooterComponent,
    HeaderComponent,
    NavbarComponent,
    BreadcrumbsModule,
    RouterModule,
    WrapperComponent,
  ],
  templateUrl: './without-reza-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class WithoutRezaLayoutComponent implements OnInit {
  private breadcrumbsService = inject(BreadcrumbsService);
  readonly windowRef = inject<Window>(WINDOW);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  hideBreadcrumb = true;

  breadcrumbs$ = this.breadcrumbsService.breadcrumbs$.pipe(
    map((breadcrumbs: Breadcrumb[]) => {
      return [
        {
          icon: 'pi pi-home',
          routerLink: `/`,
          label: 'home',
        } as MenuItem,
        ...breadcrumbs,
      ];
    })
  );

  ngOnInit(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.updateRouteAttributes();
    });

    this.breadcrumbsService.init();
    this.updateRouteAttributes();
  }

  private updateRouteAttributes(): void {
    let route = this.activatedRoute.firstChild;
    while (route?.firstChild) {
      route = route.firstChild;
    }

    this.hideBreadcrumb = route?.snapshot.data['hideBreadcrumb'] === true;
  }
}
